import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {VerityPriceModel} from '../models/verity-price-model';
import {SortTypes} from './sort-tpes';

@Injectable({
  providedIn: 'root'
})
export class FilterHeaderService {

  public filterName = '';
  public selectedFilterTypes = [];
  public selectedFilterEntries = {};

  public toggleState: boolean;

  constructor(private http: HttpClient) {
  }

  public generateFilterEntries(data: Array<any>, exceptColumn?: string, currentFilterEntries?: Array<any>) {
    const filterEntriesData = {};

    if (data && data.length > 0) {
      const keys = Object.keys(data[0]);

      if (exceptColumn) {
        keys.splice(keys.indexOf(exceptColumn), 1);
        filterEntriesData[exceptColumn] = currentFilterEntries[exceptColumn];
      }

      keys.forEach(key => {
          this.addFilterEntries(data, key, filterEntriesData);
        }
      );
    }

    return filterEntriesData;
  }

  private addFilterEntries(data: Array<any>, key, filterEntriesData) {
    const columnEntries = new Set<any>();

    data.map(row => row[key])
      .forEach(entry => columnEntries.add(entry));

    const sortType = this.getSortType(key);
    const sortPredicate = this.getSortPredicate(sortType);

    const entries = Array.from(columnEntries.values());

    filterEntriesData[key] = entries.sort(sortPredicate);
  }

  public addAllEntriesToFilter(key: string, headerFilterEntries: any, data: VerityPriceModel[]) {
    if (data && data.length > 0) {
      this.addFilterEntries(data, key, headerFilterEntries);
    }
  }

  private getSortType(key: string): SortTypes {

    const unitTypeKeys = ['strength', 'Strength'];
    const numericTypeKeys = ['Package_size',
      'ExF_excl_VAT',
      'ExF_excl_VAT_from',
      'ExF_excl_VAT_to',
      'ExF_excl_VAT_diff',
      'WHS_excl_VAT',
      'WHS_excl_VAT_from',
      'WHS_excl_VAT_to',
      'WHS_excl_VAT_diff',
      'Ret_excl_VAT',
      'Ret_excl_VAT_from',
      'Ret_excl_VAT_to',
      'Ret_excl_VAT_diff',
      'Ret_incl_VAT',
      'Ret_incl_VAT_from',
      'Ret_incl_VAT_to',
      'Ret_incl_VAT_diff'
    ];

    if (unitTypeKeys.indexOf(key) !== -1) {
      return SortTypes.UNIT;
    }

    if (numericTypeKeys.indexOf(key) !== -1) {
      return SortTypes.NUMERIC;
    }

    return SortTypes.DEFAULT;
  }

  private getSortPredicate(type: SortTypes) {

    switch (type) {
      case SortTypes.DEFAULT: {
        return (a, b) => {
          try {
            const aString = a.toLowerCase();
            const bString = b.toLowerCase();

            if (aString < bString) {
              return -1;
            }

            if (aString > bString) {
              return 1;
            }

            return 0;
          } catch (e) {
            return 0;
          }
        };
      }

      case SortTypes.NUMERIC: {
        return (a, b) => {
          return a - b;
        };
      }

      case SortTypes.UNIT: {
        return (a, b) => {
          const valA = a.substring(0, a.indexOf(' '));
          const valB = b.substring(0, b.indexOf(' '));

          return valA - valB;
        };
      }
    }
  }

  public loadFilterNames() {
    return this.http.post('/filters/', {
      mode: 'get_names',
    });
  }

  public saveFilters(saveName: string) {
    return this.http.post('/filters/', {
      mode: 'post',
      filter_name: saveName,
      filters: JSON.stringify({
        selectedFilterTypes: this.selectedFilterTypes,
        selectedFilterEntries: this.selectedFilterEntries
      })
    });
  }

  public loadChoices(filterName: string) {
    return this.http.post('/filters/', {
      mode: 'get',
      filter_name: filterName
    });
  }

  public deleteChoice(filterName: string) {
    return this.http.post('/filters/', {
      mode: 'delete',
      filter_name: filterName
    });
  }
}
